import React from "react";
import { useTenant } from "../contexts/TenantContext";
import { formatPhone } from "../utils/formatPhone";

const DMCAPage: React.FC = () => {
  const { config } = useTenant();
  const orgName = config?.orgData?.org_name || "";
  const orgEmail = config?.orgData?.email || "";

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="prose max-w-none">
        <h1 className="text-3xl font-bold mb-8">
          DMCA Notice & Takedown Policy
        </h1>

        <div className="mb-8">
          <p>
            This website is protected by the Digital Millennium Copyright Act
            (DMCA). If you believe your copyrighted work is being infringed,
            please contact us with proper documentation for removal.
          </p>
        </div>

        {/* Contact Information */}
        <div className="mt-8">
          <h2 className="text-lg font-bold mb-2">Contact Information:</h2>
          <p>
            Kyle Fedewa
            <br />
            Email:{" "}
            <a
              href="mailto:kyle@thespeculogroup.com"
              className="text-primary underline"
            >
              kyle@thespeculogroup.com
            </a>
            <br />
            Phone:{" "}
            <a href="tel:+19375104461" className="text-primary underline">
              +1 (937) 510-4461
            </a>
            <br />
            Mailing Address: 7972 Southbury Dr Dayton, OH 45458
          </p>
        </div>
      </div>
    </div>
  );
};

export default DMCAPage;
